import { HttpParams } from '@angular/common/http';

export const getHttpParams = (params: {[paramId: string]: any}): HttpParams => {
  let httpParams = new HttpParams();
  for (const paramId in params) {
    if (params[paramId]) {
      httpParams = httpParams.set(paramId, params[paramId]);
    }
  }
  return httpParams;
};
